export const RETAIL_CTA_TYPES = {
  PHONE: 'phone',
  LINK: 'link',
};
